/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "../../../components/MDBadge";

export default function buildUserTable(data, onEdit) {
  const UserName = ({ name, role }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{role}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const columns = [
    { Header: "name", accessor: "userName", width: "45%", align: "left" },
    { Header: "email", accessor: "email", align: "center" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = data.map((item) => {
    return {
      userName: <UserName name={item.name} role={item.role} />,
      email: (
        <MDTypography display="block" variant="button" fontWeight="medium">
          {item.email}
        </MDTypography>
      ),
      action: (
        <MDTypography
          component="a"
          href="#"
          variant="caption"
          color="text"
          fontWeight="medium"
          onClick={(e) => {
            e.preventDefault();
            onEdit(item.id);
          }}
        >
          Edit
        </MDTypography>
      ),
    };
  });

  return { columns, rows };
}
